import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import * as _ from 'lodash';
import { CommonEmptyDataV1, CommonFullDetailViewV1 } from 'gemlux-common-components';
import { styled as materialStyled } from '@mui/material/styles';

import { Box, Typography } from '@mui/material';
import { toast } from 'react-hot-toast';
import { pdf } from '@react-pdf/renderer';
// @ts-ignore
import { saveAs } from 'file-saver';
import GemDetails from '../../../components/MyGemVault/GemRecord/GemDetails';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { gemActions, IGem } from '../../../redux/gem/gemSlice';
import GemGallery from '../../../components/MyGemVault/GemGalary/GemGallery';
import GemAIInference from '../../../components/MyGemVault/GemAIInference/GemAIInference';
import useEnv from '../../../utils/use-env-hook';
import PlaceholderGemSvg from '../../../assets/img/gem-svgrepo-com.svg';

import { useAuth } from '../../../context/AuthContext';
import { GemBankType } from '../../../utils/enums/gem-bank.enum';
import { UsageType } from '../../../utils/enums/usage-type.enum';
import { AiStatus } from '../../../utils/enums/gem-ai-status.enum';
import { RootState } from '../../../redux/store';
import { websocketActions } from '../../../redux/webSocket/webSocketSlice';
import { getGemMediaDownloadUrl } from '../../../api/gemApi';
import { toastStyles } from '../../../utils/styles';
// eslint-disable-next-line max-len
import { GemPassportConfirmationModal } from '../../../components/GemPassport/GemPassportAiConfirmation/GemPassportAiConfirmation';
import { GemPassport } from '../../../components/GemPassport/GemPassport';
import { fetchImageAsBase64 } from '../../../utils/image.utill';
import { modelAction } from '../../../redux/models/modelsSlice';
import { Permission } from '../../../utils/enums/permission.enum';
import { Roles } from '../../../utils/enums/roles.enum';
import { theme } from '../../../theme/theme';
import AlertFill from '../../../assets/img/alert-fill.svg';

const expandedRowColumns = [
  'Species',
  'Primary Color',
  'Secondary Color',
  'Intensity',
  'Shape',
  'Weight(ct)',
  'Clarity',
  'Special Color Descriptor',
  'Cut',
  'Dimensions',
  'Treatment',
  'Gem Lab',
  'Origin',
  'Location',
  'Listing Date',
];

const expandedRowValues = [
  'species',
  'color',
  'secondaryColor',
  'intensity',
  'shape',
  'weight',
  'clarity',
  'specialDescriptor',
  'cut',
  'dimensions',
  'treatment',
  'certificate',
  'origin',
  'location',
  'scannedDate',
];

const StyledGemImage = materialStyled('img')({
  width: '100%',
  height: 'auto',
  userSelect: 'none',
  borderRadius: '5px',
  objectFit: 'contain',
});

function GemRecord() {
  const { gemId } = useParams();
  const location = useLocation();
  const { user } = useAuth();
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGemPassportLiteDownloading, setIsGemPassportLiteDownloading] = useState(false);
  const [isGemPassportLoading, setIsGemPassportLoading] = useState(false);
  const [isAiConfirmationModalOpen, setIsAiConfirmationModalOpen] = useState(false);
  const [isGemPassportLite, setIsGemPassportLite] = useState(true);
  const mediaDownloadData = useAppSelector((state: RootState) => state.websocket.gemMediaDownloadData);
  const gemPassportData = useAppSelector((state: RootState) => state.websocket.generateGemPassportData);
  const gemAiStatusdata = useAppSelector((state: RootState) => state.websocket.gemAiStatusdata);
  const { generateGemPassportLoading } = useAppSelector((state: RootState) => state.gem.componentStatus);
  const { generateGemPassportLiteLoading } = useAppSelector((state: RootState) => state.gem.componentStatus);
  const { componentStatus, gem, favourites } = useAppSelector((state) => state.gem);
  const isGemPassportLiteFirstTimeGenerated = useAppSelector(
    (state: RootState) => state.gem.isGemPassportLiteFirstTimeGenerated,
  );
  const getGemLoading = Boolean(_.get(componentStatus, 'getGemLoading', false));
  const addRemoveFavouriteGemLoading = Boolean(_.get(componentStatus, 'addRemoveFavouriteGemLoading', false));
  const gemTitle =
    `${gem?.species || ''} ${gem?.color || ''} ${gem?.shape || ''} ${gem?.weight ? `${gem.weight}ct` : ''}`.trim();
  const pathParts = location.pathname.split('/');
  const firstPathPart = `/${pathParts[1]}`;
  const isFromMyGemFavBool = firstPathPart.includes('my-gem-fav') || firstPathPart.includes('gem-bank');
  const hasExceededGemPassportLimit = user.usage.find(
    (item: { type: UsageType }) => item.type === UsageType.GEM_PASSPORT,
  )?.exceeded;
  const hasExceededGemPassportLiteLimit = user.usage.find(
    (item: { type: UsageType }) => item.type === UsageType.GEM_PASSPORT_LITE,
  )?.exceeded;
  const isButtonDisabled = gem?.aiStatus !== AiStatus.COMPLETED;
  const isBelongsToSameOrganization = user.organizationId === gem?.organizationId;
  const isaPaymentOverdue = user.isPaymentOverdue || false;
  const [openZoomPan, setOpenZoomPan] = useState(false);
  const { baseUrl = '' } = useEnv();
  const dispatch = useAppDispatch();

  const isGemFromMyOrg = gem?.organizationId === user.organizationId;
  const additionalColumns = isGemFromMyOrg ? [] : ['Owner', 'Organization'];
  const additionalValues = isGemFromMyOrg ? [] : ['user', 'organization'];
  const showPublicIcon = gem?.is_scanned && gem.organizationId === user.organizationId;

  const orderedExpandedRowColumns = Array.from(new Set([...expandedRowColumns, ...additionalColumns]));

  const orderedExpandedRowValues = Array.from(new Set([...expandedRowValues, ...additionalValues]));
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  const togglePublic = () => {
    if (gemId) {
      dispatch(gemActions.togglePublicGemAsync({ gemId }));
    }
  };

  const tabs = [
    {
      label: 'Gem Profile',
      children: (
        <GemDetails
          expandedRowColumns={orderedExpandedRowColumns}
          expandedRowValues={orderedExpandedRowValues}
          gem={gem}
        />
      ),
    },
    {
      label: 'Gallery',
      children: <GemGallery />,
    },
    {
      label: 'AI Inference',
      children: <GemAIInference gem={gem} />,
    },
  ];
  const toggleFavourite = (id: string, favouriteId?: string) => {
    if (!favourites.includes(id)) {
      dispatch(gemActions.addRemoveFavouriteGemAsync({ gemId: id }));
    } else {
      dispatch(gemActions.addRemoveFavouriteGemAsync({ gemId: id, favouriteId }));
    }
  };
  const handleImageClick = () => {
    setOpenZoomPan(true);
  };

  const handleClose = () => {
    setOpenZoomPan(false);
  };

  const aiConfirmationAction = async (isConfirmed: boolean) => {
    setIsAiConfirmationModalOpen(false);
    setIsGemPassportLiteDownloading(isGemPassportLite);
    setIsGemPassportLoading(!isGemPassportLite);
    if (gem) {
      try {
        let appearanceImage = `${baseUrl}/${gem.appearanceImage}`;
        appearanceImage = await fetchImageAsBase64(appearanceImage);
        const blob = await pdf(
          <GemPassport
            gem={{ ...gem, appearanceImage }}
            includeAiResponse={isConfirmed}
            isPassportLight={isGemPassportLite}
          />,
        )
          .toBlob()
          .finally(() => {
            setIsGemPassportLiteDownloading(false);
            setIsGemPassportLoading(false);
          });
        let pdfName = `${gem.systemId}_${gem.version ?? 0.0}`;
        pdfName += isGemPassportLite ? '_GemPassportLite.pdf' : '_GemPassport.pdf';

        saveAs(blob, pdfName);
      } catch (error) {
        toast.error('Failed to generate PDF.', toastStyles.error);
      }
    } else {
      toast.error('Failed to generate PDF.', toastStyles.error);
    }
  };

  const handleGemPassportDownload = async (isLite: boolean) => {
    if (!gem) return;
    const hasGeneratePassportPermission = user.permissions.includes(Permission.GENERATE_PASSPORT);
    const hasGemVaultPermission = user.permissions.some((permission: Permission) =>
      [Permission.VIEW_MY_GEM_VAULT, Permission.VIEW_POROLIS_GEM_BANK].includes(permission),
    );
    if (!((hasGeneratePassportPermission && hasGemVaultPermission) || user.role === Roles.SAAS_ADMIN)) {
      dispatch(modelAction.setIsPermissionDeniedModelOpen(true));
      return;
    }
    if (isLite) {
      if (gem.passportLightGenerated) {
        setIsGemPassportLite(true);
        setIsAiConfirmationModalOpen(true);
        return;
      }
      dispatch(gemActions.generateGemPassportLightAsync({ gemId: gem.gemId }));
      setIsGemPassportLiteDownloading(false);
      return;
    }
    if (gem?.aiResponse?.uginId) {
      setIsGemPassportLite(false);
      setIsAiConfirmationModalOpen(true);
    }
  };

  const handleGenerateGemPassport = () => {
    if (!gem) {
      toast.error('Failed to generate Gem Passport.', toastStyles.error);
      return;
    }
    const hasGeneratePassportPermission = user.permissions.includes(Permission.GENERATE_PASSPORT);
    const hasGemVaultPermission = user.permissions.some((permission: Permission) =>
      [Permission.VIEW_MY_GEM_VAULT, Permission.VIEW_POROLIS_GEM_BANK].includes(permission),
    );
    if (!((hasGeneratePassportPermission && hasGemVaultPermission) || user.role === Roles.SAAS_ADMIN)) {
      dispatch(modelAction.setIsPermissionDeniedModelOpen(true));
      return;
    }
    dispatch(gemActions.generateGemPassportAsync({ gemId: gem.gemId }));
    setIsGemPassportLoading(true);
  };

  useEffect(() => {
    if (gemId && !addRemoveFavouriteGemLoading) {
      dispatch(gemActions.getGemByIdAsync({ gemId, type: isFromMyGemFavBool ? GemBankType.POROLIS : undefined }));
    }
  }, [gemId, addRemoveFavouriteGemLoading]);

  useEffect(() => {
    if (gemId && !addRemoveFavouriteGemLoading && gemAiStatusdata && gemAiStatusdata.gemId === gemId) {
      dispatch(gemActions.getGemByIdAsync({ gemId, type: isFromMyGemFavBool ? GemBankType.POROLIS : undefined }));
      dispatch(websocketActions.setGemAiStatusData(null));
    }
  }, [gemId, gemAiStatusdata, addRemoveFavouriteGemLoading]);

  const handleDownloadImage = async () => {
    if (gem?.gemId) {
      try {
        dispatch(websocketActions.clearGemMediaDownloadData());
        setIsImageLoading(true);
        await getGemMediaDownloadUrl(gem.gemId, 'IMAGE');
      } catch (error: any) {
        toast.error('Failed to download image.', toastStyles.error);
        setIsImageLoading(false);
      }
    }
  };

  const handleDownloadVideo = async () => {
    if (gem?.gemId) {
      try {
        setIsVideoLoading(true);
        await getGemMediaDownloadUrl(gem.gemId, 'VIDEO');
      } catch (error: any) {
        console.error('Error downloading video:', error);
        toast.error('Failed to download video.', toastStyles.error);
        setIsVideoLoading(false);
      }
    }
  };

  useEffect(() => {
    if (mediaDownloadData.status === 'ERROR') {
      toast?.error('Download Failed', toastStyles.error);
      setIsImageLoading(false);
      setIsVideoLoading(false);
    }
    if (mediaDownloadData.status === 'SUCCESS') {
      if (mediaDownloadData.gemId === gem?.gemId && mediaDownloadData.url) {
        setIsImageLoading(false);
        setIsVideoLoading(false);
        toast.success('Download Successful', toastStyles.success);
        window.open(mediaDownloadData.url, '_blank');
        dispatch(websocketActions.clearGemMediaDownloadData());
      }
    }
  }, [mediaDownloadData]);

  useEffect(() => {
    if (gemPassportData?.status === 'ERROR') {
      setIsGemPassportLoading(false);
      toast.error('Failed to generate Gem Passport.', toastStyles.error);
      return;
    }
    if (gemPassportData?.status === 'SUCCESS' && gemPassportData.gemId === gem?.gemId) {
      setIsGemPassportLoading(false);
      if (gemId && !addRemoveFavouriteGemLoading) {
        dispatch(gemActions.updateGemUginIdAsync({ uginId: gemPassportData.uginId }));
      }
    }
  }, [gemPassportData]);

  useEffect(() => {
    if (gemPassportData?.uginId) {
      dispatch(gemActions.setUginIdAsync({ uginId: gemPassportData.uginId }));
    }
  }, [gemPassportData?.uginId]);

  useEffect(() => {
    if (gem?.aiResponse?.uginId && gemPassportData.uginId) {
      handleGemPassportDownload(false);
    }
  }, [gem?.aiResponse?.uginId]);

  useEffect(() => {
    if (isGemPassportLiteFirstTimeGenerated) {
      setIsGemPassportLite(true);
      setIsAiConfirmationModalOpen(true);
      dispatch(gemActions.setGemPassportLiteFirstTimeGenerated(false));
    }
  }, [isGemPassportLiteFirstTimeGenerated]);

  const formattedGem = (prevGem: IGem): any => {
    const imageUrl = prevGem?.appearanceImage ? `${baseUrl}/${prevGem.appearanceImage}` : '';
    return {
      ...prevGem,
      image: (
        <StyledGemImage
          src={imageUrl}
          alt="Gem Image"
          onError={(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
            const img = event.currentTarget as HTMLImageElement;
            img.src = PlaceholderGemSvg;
          }}
        />
      ),
      placeHolderImage: (
        <Box
          component="img"
          alt="Gem Image"
          src={imageUrl}
          width="250px"
          height="250px"
          borderRadius="5px"
          onError={(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
            const img = event.currentTarget as HTMLImageElement;
            img.src = PlaceholderGemSvg;
          }}
          onClick={handleImageClick}
          sx={{ cursor: 'pointer' }}
        />
      ),
    };
  };

  if (!gem && !getGemLoading) {
    return (
      <CommonEmptyDataV1 title="No Gem Record found" description=" Sorry, we couldn't find any record for this Gem." />
    );
  }
  return (
    <Box>
      <GemPassportConfirmationModal
        open={isAiConfirmationModalOpen}
        onDismiss={() => setIsAiConfirmationModalOpen(false)}
        onConfirm={() => aiConfirmationAction(true)}
        onCancel={() => aiConfirmationAction(false)}
      />

      <CommonFullDetailViewV1
        hasExceededGemPassportLimit={hasExceededGemPassportLimit}
        hasExceededGemPassportLiteLimit={hasExceededGemPassportLiteLimit}
        isButtonDisabled={isButtonDisabled}
        isBelongsToSameOrganization={isBelongsToSameOrganization}
        isLoading={getGemLoading}
        title={gemTitle}
        gem={gem && formattedGem(gem)}
        handleFavourite={() => gem?.gemId && toggleFavourite(gem.gemId, gem.favouriteId)}
        tabs={gem?.is_scanned ? tabs : [tabs[0]]}
        activeTab={activeTab}
        onChange={handleTabChange}
        handleClose={handleClose}
        openZoomPan={openZoomPan}
        onDownloadImageClick={handleDownloadImage}
        onDownloadVideoClick={handleDownloadVideo}
        isDownloadImageLoading={isImageLoading}
        isDownloadVideoLoading={isVideoLoading}
        onDownloadGemPassPort={() => handleGemPassportDownload(false)}
        onDownloadGemPassportLite={() => handleGemPassportDownload(true)}
        onGenerateGemPassport={handleGenerateGemPassport}
        isDownloadGemPassportLiteLoading={(generateGemPassportLiteLoading as boolean) || isGemPassportLiteDownloading}
        isDownloadGemPassportLoading={(generateGemPassportLoading as boolean) || isGemPassportLoading}
        isPaymentOverdue={isaPaymentOverdue}
        downloadImageLoadingText={mediaDownloadData.loadingStage}
        downloadVideoLoadingText={mediaDownloadData.loadingStage}
        isPublic={gem?.isPublic}
        showPublicIcon={showPublicIcon}
        togglePublic={() => togglePublic()}
      />

      {(isImageLoading || isVideoLoading) && (
        <Box sx={{ position: 'fixed', bottom: 15, right: 15 }}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box component="img" src={AlertFill} alt="Alert Icon" />
            <Typography variant="tableheadBold" sx={{ color: theme.palette.shades.errorBrightMain, paddingLeft: 1 }}>
              Do not refresh or close the window!
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default GemRecord;
